/**
 * Type Beauty — small shared DOM / cart helpers (vanilla JS).
 */
(function (window) {
  'use strict';

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function closest(el, selector) {
    return el && el.closest ? el.closest(selector) : null;
  }

  function on(root, type, selector, handler, options) {
    (root || document).addEventListener(
      type,
      function (e) {
        var match = selector ? closest(e.target, selector) : e.target;
        if (!match) return;
        if (selector && root && root !== document && !root.contains(match)) return;
        handler.call(match, e, match);
      },
      options || false
    );
  }

  function handleize(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function debounce(fn, wait) {
    var timer = null;
    return function () {
      var ctx = this;
      var args = arguments;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function fetchJson(url, options) {
    var opts = options || {};
    var headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    if (opts.body && typeof opts.body === 'object' && !(opts.body instanceof FormData)) {
      headers['Content-Type'] = headers['Content-Type'] || 'application/json';
      opts = Object.assign({}, opts, {
        headers: headers,
        body: JSON.stringify(opts.body)
      });
    } else {
      opts = Object.assign({}, opts, { headers: headers });
    }
    return fetch(url, opts).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || res.statusText);
          err.status = res.status;
          err.responseJSON = data;
          throw err;
        }
        return data;
      });
    });
  }

  function getCart() {
    return fetchJson('/cart.js');
  }

  function addToCart(payload) {
    return fetchJson('/cart/add.js', { method: 'POST', body: payload });
  }

  function changeCart(payload) {
    return fetchJson('/cart/change.js', { method: 'POST', body: payload });
  }

  function clearCart() {
    return fetchJson('/cart/clear.js', { method: 'POST', body: {} });
  }

  function formatInr(cents) {
    return '₹ ' + parseFloat((Number(cents) || 0) / 100);
  }

  function setText(selector, text, root) {
    qsa(selector, root).forEach(function (el) {
      el.textContent = text;
    });
  }

  function setHtml(selector, html, root) {
    qsa(selector, root).forEach(function (el) {
      el.innerHTML = html;
    });
  }

  function show(el) {
    if (!el) return;
    el.style.display = '';
    if (el.style.display === 'none') el.style.display = 'block';
  }

  function hide(el) {
    if (!el) return;
    el.style.display = 'none';
  }

  function showAll(selector, root) {
    qsa(selector, root).forEach(show);
  }

  function hideAll(selector, root) {
    qsa(selector, root).forEach(hide);
  }

  /** Simple fade-in / delayed fade-out. */
  function flashEl(selector, visibleMs) {
    var el = typeof selector === 'string' ? qs(selector) : selector;
    if (!el) return;
    var ms = visibleMs == null ? 3000 : visibleMs;
    el.style.transition = 'opacity 0.2s ease';
    el.style.opacity = '0';
    el.style.display = 'block';
    requestAnimationFrame(function () {
      el.style.opacity = '1';
    });
    clearTimeout(el.__tbFlashTimer);
    el.__tbFlashTimer = setTimeout(function () {
      el.style.opacity = '0';
      setTimeout(function () {
        el.style.display = 'none';
      }, 220);
    }, ms);
  }

  function fadeOutRemove(el, duration) {
    if (!el) return;
    var ms = duration == null ? 200 : duration;
    el.style.transition = 'opacity ' + ms + 'ms ease';
    el.style.opacity = '0';
    setTimeout(function () {
      if (el.parentNode) el.parentNode.removeChild(el);
    }, ms);
  }

  function dispatch(name, detail) {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: detail || null, bubbles: true }));
    } catch (e) {
      /* older browsers */
    }
  }

  function text(el) {
    return el ? (el.textContent || '').trim() : '';
  }

  function val(el) {
    if (!el) return '';
    return el.value != null ? el.value : '';
  }

  window.TBUtils = {
    qs: qs,
    qsa: qsa,
    closest: closest,
    on: on,
    handleize: handleize,
    debounce: debounce,
    fetchJson: fetchJson,
    getCart: getCart,
    addToCart: addToCart,
    changeCart: changeCart,
    clearCart: clearCart,
    formatInr: formatInr,
    setText: setText,
    setHtml: setHtml,
    show: show,
    hide: hide,
    showAll: showAll,
    hideAll: hideAll,
    flashEl: flashEl,
    fadeOutRemove: fadeOutRemove,
    dispatch: dispatch,
    text: text,
    val: val
  };
})(window);
